/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Button } from 'antd';
import { ImportOutlined } from '@ant-design/icons';
import { IDataModal } from '@/interfaces/dataModal';
import ImportStockMatchingModal from '@/components/import/stock-matching/stock-matching-modal';

interface IProps {
  onImported: () => void;
}

const _importModal: IDataModal<any> = {
  open: false,
};

const ImportExcel = ({ onImported }: IProps) => {
  const [importModal, setImportModal] = useState<IDataModal<any>>({
    ..._importModal,
  });

  return (
    <div>
      <Button
        ghost
        type="primary"
        onClick={() => {
          setImportModal({
            open: true,
            id: 'coa',
          });
        }}
      >
        <ImportOutlined />
        Import Excel
      </Button>
      <ImportStockMatchingModal
        open={importModal?.open}
        handleOk={function (): void {
          setImportModal({ ..._importModal });
          onImported();
        }}
        handleCancel={function (): void {
          setImportModal({ ..._importModal });
        }}
      />
    </div>
  );
};

export default ImportExcel;
